import "../SelectField/SelectField.scss";
import AsyncSelect from "react-select/async"; // ← Changed
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Controller } from "react-hook-form";

export const AsyncSelectField = ({
  onChange = () => {},
  name = "",
  control,
  ...props
}) => {
  return (
    <>
      {control ? (
        <Controller
          control={control}
          name={name}
          render={({ field: { onChange: onControllerChange } }) => (
            <BaseSelectField
              name={name}
              control={control}
              onChange={(value, label) => {
                onControllerChange(value);
                onChange(value, label);
              }}
              {...props}
            />
          )}
        />
      ) : (
        <BaseSelectField
          name={name}
          onChange={(value) => {
            onChange(value);
          }}
          {...props}
        />
      )}
    </>
  );
};

export const BaseSelectField = ({
  value,
  onChange = () => {},
  options = [],
  idKey,
  nameKey,
  placeholder,
  isRequired = false,
  label = null,
  labelDescription = null,
  isDisabled = false,
  isSearchable = true,
  errorMessage = undefined,
  floatError = true,
  giveControl = true,
  classNames = "",
  backgroundColor,
  selectInputRef = null,
  minHeight = "50px",
  sideLabel = "",
  loadOptions = async () => {},
  ...rest
}) => {
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderColor:
        state.isFocused || errorMessage !== undefined
          ? `${
              errorMessage !== undefined
                ? "#979797"
                : state.isFocused
                  ? "#7647ee"
                  : backgroundColor
            } !important`
          : "#cccccc",
      boxShadow: "none",
      "&:hover": {
        borderColor: backgroundColor
          ? `${backgroundColor} !important`
          : "#7647ee !important",
        boxShadow: "none",
      },
      borderWidth: "0.5px",
      minHeight: minHeight,
    }),
    option: (styles, { isFocused }) => ({
      ...styles,
      backgroundColor: isFocused ? backgroundColor || "#7647ee" : null,
      color: isFocused ? "#fff" : null,
      zIndex: 10,
    }),
    menu: (base) => ({
      ...base,
      zIndex: 10,
    }),
  };

  return (
    <div className={`custom-dropdown ${classNames}`} {...rest}>
      {label !== null && (
        <>
          <label htmlFor="" data-testid="label">
            {isRequired && <span className="text-danger">*</span>}
            <span>{label}</span>
          </label>
          {labelDescription ? (
            <span className="d-block gray--text smallest-text-size mb-1">
              {labelDescription}
            </span>
          ) : null}
        </>
      )}

      <div className="custom-dropdown__wrapper">
        {sideLabel ? (
          <span className="custom-dropdown__label">{sideLabel}</span>
        ) : null}

        <AsyncSelect
          ref={selectInputRef}
          className="custom-dropdown__select"
          classNamePrefix="custom-dropdown__select"
          // Async-specific props:
          loadOptions={loadOptions}
          defaultOptions={true} // Show options when input is empty
          // Standard props:
          cacheOptions
          defaultValue={value ? { value, label: value } : null}
          onChange={(answer) => onChange(answer?.value, answer?.label)}
          value={!giveControl ? { value: value, label: value } : undefined}
          placeholder={placeholder}
          isDisabled={isDisabled}
          isSearchable={isSearchable}
          styles={customStyles}
          // Optional: Customize noOptions message
          noOptionsMessage={({ inputValue }) =>
            inputValue ? "No results found" : "Type to search..."
          }
        />
      </div>

      {/* error message */}
      {(floatError || errorMessage !== undefined) && (
        <p
          className={`error-message text-danger ${
            errorMessage !== undefined ? "show" : ""
          }`}
          data-testid="error-message"
        >
          <FontAwesomeIcon
            icon={["fas", "exclamation-circle"]}
            className="mr-2"
            style={{ fontSize: "13px" }}
          />
          {errorMessage && <span>{errorMessage.message}</span>}
        </p>
      )}
    </div>
  );
};
